"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditProviders = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal"); // tkay added confirmation modal to confirm provider delete
const filter_header_1 = require("client/components/filter-header");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const router_1 = require("client/components/router");
const upload_modal_1 = require("client/components/upload-modal");
const edit_provider_1 = require("client/modules/providers/modules/providers-list/components/edit-provider");
const store_1 = require("client/modules/providers/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
require("./edit-providers.less");
const Warning_1 = require("material-ui-icons/Warning"); // C-095.41
const store_3 = require("client/modules/app-settings/store"); // C-095.41
const app_settings_1 = require("shared/app-settings"); // C-095.41
const ReactTooltip = require("react-tooltip"); // C-095.41
const Notifications_1 = require("material-ui-icons/Notifications"); // C-095.421 
const columns = [
    {
        center: false,
        id: "provider.lastName",
        numeric: false,
        label: "Name"
    },
    {
        center: true,
        id: "provider.title",
        numeric: false,
        label: "Title"
    },
    {
        center: false,
        id: "provider.npiNumber",
        numeric: false,
        label: "NPI"
    },
    {
        center: false,
        id: "provider.dea",
        numeric: false,
        label: "DEA"
    },
    {
        center: false,
        id: "provider.deaExp",
        numeric: false,
        label: "DEA LIC Exp"
    },
    {
        center: false,
        id: "provider.stateLicense",
        numeric: false,
        label: "State Lic"
    },
    {
        center: false,
        id: "provider.stateLicenseExp",
        numeric: false,
        label: "STATE LIC EXP"
    },
    {
        label: '',
        id: "provider.id",
    } // C-095.5
    ,
    {
        label: "",
        id: "provider.id"
    }
];
const today = new Date(); // new Date().toString() to new Date()
const dummyProvider = {
    email: "",
    firstName: "",
    lastName: "",
    prefix: "",
    suffix: "",
    id: 0,
    phone: "",
    dea: "",
    deaExp: today,
    npiNumber: "",
    state: "",
    stateLicense: "",
    stateLicenseExp: today,
    title: ""
};
let EditProviders = class EditProviders extends react_1.Component {
    constructor() {
        super(...arguments);
        this.confirmDeleteProvider = null;
        this.order = "ASC";
        this.orderBy = "provider.lastName";
        this.editId = -1;
        this.currentRowIndex = -1;
        this.isCollapse = true;
        this.filterText = "";
        this.autoFocusForm = true;
        this.uploadModal = false;
        this.provider = ramda_1.merge(dummyProvider, {});
        this.daysPrior = 0; // C-095.41
        this.onRequestSort = async (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            await this.loadProviders();
        };
        this.onHandleSave = async (provider) => {
            this.provider = provider; // Why?
            const newProvider = provider.id
                ? await store_1.providersStore.saveProvider(provider)
                : await store_1.providersStore.createProvider(provider);
            await this.loadProviders();
            await store_2.sitesDetailStore.readSite(this.siteId);
            if (newProvider) {
                router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/providers/${newProvider.id}`);
            }
        };
        this.onHandleClickDeleteProvider = (provider) => {
            this.confirmDeleteProvider = provider;
        };
        this.onHandleClickConfirmDeleteProvider = async () => {
            if (this.confirmDeleteProvider) {
                await store_1.providersStore.deleteProvider(this.confirmDeleteProvider);
                this.confirmDeleteProvider = null;
            }
            await this.loadProviders(); // tkay added reload providers to update provider list
        };
        this.onHandleClickCancelDeleteProvider = () => {
            this.confirmDeleteProvider = null;
        };
        this.onHandleClickRow = (row, index) => {
            if (this.editId === row.id) {
                this.isCollapse = !this.isCollapse;
                this.autoFocusForm = true;
            }
            else {
                // C-095.41  
                if (this.siteId) {
                    router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/providers/${row.id}`);
                }
            }
            this.editId = row.id;
            this.currentRowIndex = index;
        };
        this.onCallback = async (value) => {
            this.filterText = value;
            await this.loadProviders();
            this.autoFocusForm = false;
        };
        this.loadProviders = async () => {
            if (store_2.sitesDetailStore.site.value) {
                await store_2.sitesDetailStore.loadProviders({
                    id: store_2.sitesDetailStore.site.value.id,
                    order: this.order,
                    search: this.filterText,
                    sort: this.orderBy
                });
                await store_2.sitesDetailStore.loadEditProviders({
                    id: store_2.sitesDetailStore.site.value.id,
                    order: this.order,
                    search: this.filterText,
                    sort: this.orderBy
                });
            }
        };
        this.onHandleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        this.onHandleClickDeleteUpload = async (upload) => {
            await store_1.providersStore.deleteUpload(upload);
            await this.loadProviders();
        };
        this.onHandleCredentialUpload = (provider) => {
            this.uploadType = "credential";
            this.uploadModal = true;
        };
        this.onHandleImageUpload = (provider) => {
            this.uploadType = "image";
            this.uploadModal = true;
        };
        this.handleAssetsUpload = async (accepted) => {
            await store_2.sitesDetailStore.upload(accepted, String(this.editId), this.uploadType, "Provider");
            await this.loadProviders();
        };
        this.renderTable = () => (React.createElement("div", { className: "providers__list" }, store_2.sitesDetailStore.providers.value && (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_2.sitesDetailStore.providers.value, renderRow: this.renderTableRow, wideHeader: false, resizableheader: true, customClass: "custom-material-list__site-providers-list providers__liststicky" // C-095.55  // C-095.541 adding the css class
         }))));
        this.renderEditNewProvider = () => (React.createElement("div", { className: "providers__new-provider" },
            React.createElement(edit_provider_1.EditProvider, { autoFocusForm: this.autoFocusForm, error: store_1.providersStore.editProvider.error, loading: store_1.providersStore.editProvider.loading, onCancel: () => {
                    this.siteId === undefined ? false : router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/providers`); // C-095.421
                    store_1.providersStore.editProvider.error = undefined;
                }, onSave: this.onHandleSave, provider: this.provider, status: store_1.providersStore.editProvider.status, newProvider: true })));
        this.renderTableRow = (row, index) => {
            const isShowEdit = !this.isCollapse && this.props.providerId === row.id;
            const tableRowContent = [this.renderTableRowPlain(row, index)];
            isShowEdit && tableRowContent.push(this.renderListRowEditMode(row, index));
            return tableRowContent;
        };
        this.renderTableRowPlain = (row, index) => {
            const displayName = `${row.lastName}, ${row.firstName}`;
            // C-095.41 
            const today = moment().startOf("day");
            const alertDateDEA = moment(row.deaExp)
                .subtract(this.daysPrior, "days")
                .startOf("day")
                .toString();
            const alertDateState = moment(row.stateLicenseExp)
                .subtract(this.daysPrior, "days")
                .startOf("day")
                .toString();
            const showAlertDEA = today.isBetween(alertDateDEA, row.deaExp);
            const showAlertState = today.isBetween(alertDateState, row.stateLicenseExp);
            const isExpired = today.isSameOrAfter(row.deaExp) ||
                today.isSameOrAfter(row.stateLicenseExp);
            // C-095.421 ************************************************* \/
            const missingRequiredAssetsforProvArray = this.missingRequiredAssets &&
                this.missingRequiredAssets.length &&
                this.missingRequiredAssets.filter((asset) => asset.id === row.id);
            const rowUploadsArray = row.uploads.map((upload) => upload.connectAssetId);
            //  if rowUploadsArray contains the ids or the assetsArray then it should not have a warning, and missing will be empty
            const missing = missingRequiredAssetsforProvArray &&
                missingRequiredAssetsforProvArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray &&
                missingRequiredAssetsforProvArray[0].assetsArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray.filter((num) => num && !rowUploadsArray.includes(num.id));
            let missingRequired = false;
            if (missingRequiredAssetsforProvArray &&
                missingRequiredAssetsforProvArray.length &&
                missingRequiredAssetsforProvArray[0].assetsArray &&
                missingRequiredAssetsforProvArray[0].assetsArray.length > 0 &&
                missing &&
                missing.length > 0) {
                missingRequired = true;
            }
            // C-095.421 *************************************************/\
            return (React.createElement(React.Fragment, null,
                React.createElement(ReactTooltip, { id: "warning-icon", className: "tooltip", effect: "solid", place: "left", "data-type": "warning", multiline: true }),
                React.createElement(list_item_1.MaterialListItem, { className: isExpired ? "expired-license-accent" : "", key: index, onClick: () => {
                        this.onHandleClickRow(row, index);
                    } },
                    React.createElement(list_item_text_1.MaterialListItemText, { className: "providers__name", primary: capitalize_string_1.capitalizeString(displayName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { className: "providers__name", primary: row.title }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: this.props.site && row.npiNumber }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.dea }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.deaExp ? moment(row.deaExp).format("MM/DD/YYYY") : "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.stateLicense }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: row.stateLicenseExp ? moment(row.stateLicenseExp).format("MM/DD/YYYY") : "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: showAlertDEA || showAlertState ? (React.createElement(Warning_1.default, { className: "warning-quantity--icon", "data-place": "right", "data-tip": "Provider's credential (License/DEA) is expiring soon" // C-095.421
                            , "data-for": "warning-icon", fill: "#eeb20d" })) : null }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: missingRequired ?
                            React.createElement(Notifications_1.default, { className: "warning-quantity--icon", "data-tip": "Missing required certifications", "data-place": "right", "data-for": "warning-icon", fill: "#eeb20d" })
                            : null }))));
        };
        this.renderListRowEditMode = (row, index) => (React.createElement("div", { key: row.dea, className: "provider-edit-form" },
            React.createElement(edit_provider_1.EditProvider, { autoFocusForm: this.autoFocusForm, error: store_1.providersStore.editProvider.error, key: index, loading: store_1.providersStore.editProvider.loading, onCancel: () => {
                    this.siteId === undefined ? false : router_1.RouteManager.transitionTo(`/pharmacies/${this.siteId}/providers`); // C-095.421
                    store_1.providersStore.editProvider.error = undefined;
                }, onDelete: this.onHandleClickDeleteProvider, onSave: this.onHandleSave, provider: row, status: store_1.providersStore.editProvider.status, onCredentialUpload: this.onHandleCredentialUpload, onDeleteUpload: this.onHandleClickDeleteUpload, onImageUpload: this.onHandleImageUpload, newProvider: false })));
    }
    async componentDidMount() {
        // C-095.41
        ReactTooltip.rebuild();
        await this.loadProviders();
        const daysSetting = await store_3.appSettingsStore.readSettings(app_settings_1.AppOption.DaysPriorProvExpLicense);
        this.daysPrior = Number(daysSetting.value);
        // C-095.421
        await store_1.providersStore.loadProviders();
        this.daysPrior = Number(daysSetting.value);
        const providers = store_1.providersStore.providers.value;
        const missingRequiredAssetsArray = await store_1.providersStore.getMissingRequiredAssets(providers, "provider");
        this.missingRequiredAssets = missingRequiredAssetsArray
            ? Array.from(missingRequiredAssetsArray)
            : [];
        ReactTooltip.rebuild();
    }
    componentWillReceiveProps(props) {
        this.provider = ramda_1.merge(dummyProvider, {});
        this.siteId = props.site ? props.site.id : 0;
        if (this.siteId) {
            props.site && (this.provider.sites = []);
            props.site && this.provider.sites.push(props.site);
        }
        if (!this.props.providerId) {
            this.isCollapse = true;
            this.editId = -1;
        }
        else {
            this.isCollapse = false;
        }
        this.status = props.status;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild(); // C-095.41
        if (this.props.providerId && this.editId !== this.props.providerId) {
            this.isCollapse = false;
            this.editId = this.props.providerId;
        }
        if (this.props.providerId === 0) {
            this.isCollapse = false;
            this.editId = -1;
        }
        if (this.props.providerId !== 0 && !this.props.providerId) {
            this.isCollapse = true;
            this.editId = -1;
        }
    }
    render() {
        ReactTooltip.rebuild(); // C-095.41
        const newProviderMode = this.props.providerId === 0;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "edit-providers" },
                newProviderMode && this.renderEditNewProvider(),
                this.renderFilter(),
                this.renderTable()),
            this.confirmDeleteProvider && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm and continue", cancelText: "Cancel and go back", message: `Are you sure you want to delete ${this.confirmDeleteProvider.prefix} ${this.confirmDeleteProvider.firstName} ${this.confirmDeleteProvider.lastName} ${this.confirmDeleteProvider.suffix}?`, onCancel: this.onHandleClickCancelDeleteProvider, onConfirm: this.onHandleClickConfirmDeleteProvider, title: "Are you sure you want to proceed?" })),
            this.uploadModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.onHandleClickCancelUpload, message: `Please select files for ${this.provider.prefix} ${this.provider.firstName} ${this.provider.lastName}${this.provider.suffix ? ` ${this.provider.suffix}` : ""}.`, title: "Upload Documents", onDrop: this.handleAssetsUpload, inPharmacy: true, callback: this.loadProviders }))));
    }
    renderFilter() {
        return (React.createElement("div", { className: "providers__filter" },
            React.createElement(filter_header_1.FilterHeader, { label: "Search", title: "Providers", callBack: this.onCallback, filterText: this.filterText })));
    }
};
__decorate([
    mobx_1.observable
], EditProviders.prototype, "confirmDeleteProvider", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "editId", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "uploadType", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "storeProvider", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "daysPrior", void 0);
__decorate([
    mobx_1.observable
], EditProviders.prototype, "missingRequiredAssets", void 0);
EditProviders = __decorate([
    mobx_react_1.observer
], EditProviders);
exports.EditProviders = EditProviders;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-providers/edit-providers.tsx
// module id = 4054
// module chunks = 0